import './cookie-consent.scss';

type CookieConsentBannerProps = {
  title: string;
  body: string;
  customizeLabel: string;
  rejectLabel: string;
  acceptLabel: string;
  onCustomize: () => void;
  onRejectAll: () => void;
  onAcceptAll: () => void;
};

export function CookieConsentBanner({
  title,
  body,
  customizeLabel,
  rejectLabel,
  acceptLabel,
  onCustomize,
  onRejectAll,
  onAcceptAll,
}: CookieConsentBannerProps) {
  return (
    <div className="cookie-consent__panel" role="dialog" aria-labelledby="cookie-consent-title">
      <h2 id="cookie-consent-title" className="cookie-consent__title">
        {title}
      </h2>
      <hr className="cookie-consent__divider" />
      <p className="cookie-consent__body">{body}</p>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--ghost"
          onClick={onCustomize}
        >
          {customizeLabel}
        </button>
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--ghost"
          onClick={onRejectAll}
        >
          {rejectLabel}
        </button>
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--solid"
          onClick={onAcceptAll}
        >
          {acceptLabel}
        </button>
      </div>
    </div>
  );
}
